getExperiment = require 'app/scripts/lib/experiments/simple-test'

module.exports = {
  getUnreadNotifications: (model, modelCache, notificationsSeenState) ->
    notificationsCount = model.get('notificationsCount')
    countsByGroup = notificationsSeenState.getNewNotifications(notificationsCount)

    count = Object.keys(countsByGroup).length

    count
}
